import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Spin } from "antd";

import { errorNotification } from "utils/Utils";
import { errorHandler } from "api/api/errorHandler";
import useMakeDuplicateMenu from "features/menus/hooks/useMakeDuplicateMenu";
import AppModal from "components/ui/AppModal";
import AppButton from "components/ui/AppButton";
import AppOutlineButton from "components/ui/AppOutlineButton";
import AppInput from "components/ui/AppInput";

function CloneMenu({ menuState, updateState }) {
  const { t } = useTranslation();
  const { isLoading } = useSelector((state) => state.LoaderReducer);
  const makeDuplicate = useMakeDuplicateMenu();
  const initialState = {
    name: "",
    description: "",
    _id: "",
  };
  const [editMenu, setEditMenu] = useState({
    values: { ...initialState },
    errors: { ...initialState },
  });

  const handleChange = (key, value) => {
    setEditMenu((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        [key]: value,
      },
      errors: {
        ...prevState.errors,
        [key]: "",
      },
    }));
  };

  const handleSetErrors = (key, value) => {
    setEditMenu((prevState) => ({
      ...prevState,
      errors: {
        ...prevState.errors,
        [key]: value,
      },
    }));
  };

  const EditSelectedMenu = async () => {
    const { name, description, _id } = editMenu.values;
    if (!name) {
      handleSetErrors("name", "Please enter menu name");
      return;
    }

    if (description && description?.length < 5) {
      handleSetErrors("description", "Please enter minimum 5 characters");
      return;
    }
    try {
      await makeDuplicate({ menuId: _id, menu: editMenu.values });
    } catch (error) {
      errorNotification(errorHandler(error?.message));
    }
  };

  const resetState = () => {
    setEditMenu({
      values: { ...initialState },
      errors: { ...initialState },
    });
  };

  useEffect(() => {
    const { menuInfo } = menuState || {};
    if (menuInfo && menuInfo?._id) {
      const { baseLanguage, description, _id } = menuInfo;
      setEditMenu({
        values: {
          name: baseLanguage?.name || "",
          description: description || "",
          _id: _id || "",
        },
        errors: { ...initialState },
      });
    } else {
      setEditMenu({
        values: { ...initialState },
        errors: { ...initialState },
      });
    }
    return resetState;
  }, [menuState?.cloneMenuModal, menuState?.menuInfo]);

  const handleClose = () => {
    updateState("cloneMenuModal", false);
    resetState();
  };

  const footer = (
    <div className="flex justify-end gap-3">
      <AppOutlineButton onClick={handleClose} disabled={isLoading}>
        {t("Cancel")}
      </AppOutlineButton>
      <AppButton onClick={EditSelectedMenu} loading={isLoading} disabled={isLoading}>
        {t("Save")}
      </AppButton>
    </div>
  );

  return (
    <div>
      <AppModal
        onClose={handleClose}
        footer={footer}
        title={t("Clone Menu")}
        width={500}
        open={menuState.cloneMenuModal}
      >
        <Spin spinning={isLoading}>
          <div className="py-2">
            <AppInput
              label={t("Menu Name")}
              name="name"
              placeholder={t("E.g. Delivery menu")}
              value={editMenu?.values?.name}
              mandatory
              error={editMenu?.errors?.name}
              onInput={(event) => handleChange("name", event.target.value)}
            />
          </div>
          <div className="py-2">
            <AppInput
              label={t("Menu description")}
              name="description"
              placeholder={t("E.g. menu for delivery")}
              value={editMenu?.values?.description}
              error={editMenu?.errors?.description}
              onInput={(event) => handleChange("description", event.target.value)}
            />
          </div>
        </Spin>
      </AppModal>
    </div>
  );
}

export default CloneMenu;
